import { useContext } from 'react';
import { ProductContext, productContext } from './Product';
import { ErrorField } from '../../base/ErrorField/ErrorField';
import SlInput from '@shoelace-style/shoelace/dist/react/input/index.js';
import { useTranslation } from 'react-i18next';

const ProductDimensions = () => {
	const { t } = useTranslation();
	const {
		width,
		setWidth,
		length,
		setLength,
		depth,
		setDepth,
		height,
		setHeight,
		diameter,
		setDiameter,
		error,
	} = useContext(productContext as React.Context<ProductContext>);

	const onUpdateWidth = (e: any) => {
		const v = e.target.value;
		setWidth(v.trim() === '' ? undefined : Number(v));
	};

	const onUpdateLength = (e: any) => {
		const v = e.target.value;
		setLength(v.trim() === '' ? undefined : Number(v));
	};

	const onUpdateDepth = (e: any) => {
		const v = e.target.value;
		setDepth(v.trim() === '' ? undefined : Number(v));
	};

	const onUpdateHeight = (e: any) => {
		const v = e.target.value;
		setHeight(v.trim() === '' ? undefined : Number(v));
	};

	const onUpdateDiameter = (e: any) => {
		const v = e.target.value;
		setDiameter(v.trim() === '' ? undefined : Number(v));
	};

	return (
		<div className='product__section product__section--dimensions'>
			<div className='product__section-form wrapped'>
				<div className='product__section-title'>{t('Dimensions')}</div>
				<ErrorField name='dimensions' error={error}>
					<>
						<ErrorField name='width' error={error}>
							<SlInput
								className='product__width'
								label={t('Width')}
								type='number'
								onSlInput={onUpdateWidth}
								value={width === undefined ? '' : String(width)}
								size='small'
								noSpinButtons
							>
								<div className='product__dimension-unit' slot='suffix'>
									cm
								</div>
							</SlInput>
						</ErrorField>
						<ErrorField name='length' error={error}>
							<SlInput
								className='product__length'
								label={t('Length')}
								type='number'
								onSlInput={onUpdateLength}
								value={length === undefined ? '' : String(length)}
								required={false}
								size='small'
								noSpinButtons
							>
								<div className='product__dimension-unit' slot='suffix'>
									cm
								</div>
							</SlInput>
						</ErrorField>
						<ErrorField name='depth' error={error}>
							<SlInput
								className='product__depth'
								label={t('Depth')}
								type='number'
								onSlInput={onUpdateDepth}
								value={depth === undefined ? '' : String(depth)}
								size='small'
								noSpinButtons
							>
								<div className='product__dimension-unit' slot='suffix'>
									cm
								</div>
							</SlInput>
						</ErrorField>
						<ErrorField name='height' error={error}>
							<SlInput
								className='product__height'
								label={t('Height')}
								type='number'
								onSlInput={onUpdateHeight}
								value={height === undefined ? '' : String(height)}
								size='small'
								noSpinButtons
							>
								<div className='product__dimension-unit' slot='suffix'>
									cm
								</div>
							</SlInput>
						</ErrorField>
						<ErrorField name='diameter' error={error}>
							<SlInput
								className='product__diameter'
								label={t('Diameter')}
								type='number'
								onSlInput={onUpdateDiameter}
								value={diameter === undefined ? '' : String(diameter)}
								size='small'
								noSpinButtons
							>
								<div className='product__dimension-unit' slot='suffix'>
									cm
								</div>
							</SlInput>
						</ErrorField>
					</>
				</ErrorField>
			</div>
		</div>
	);
};

export { ProductDimensions };
